// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2YDod","name":"Header_name__2qKlj","birthday":"Header_birthday__1soB7","skeleton":"Header_skeleton__cSttC"};